import { ProgramAPI } from '@/api'

const DefaultForm = function() {
  this.stageId = null;
  this.fertigationInterval = null;
  this.irrigationInterval = null;
  this.waterPerStage = null;
  this.prevWaterPerStage = null;
  this.temperature = 5;
};

export default {
  namespaced: true,
  state: {

    form: new DefaultForm(),
    tanks: [],
    stages: []
  },
  mutations: {
    reset(state) {
      state.form = new DefaultForm();
      state.tanks = [];
    },
    setForm(state, form) {
      state.form = form;
      state.form.prevWaterPerStage = state.form.waterPerStage;
    },


    /**
     * Это хрень нужна для костыля алго - у них это работает релятивно к прошлому состоянию 
     * @param {*} state 
     * @param {*} form 
     */
    setNewPrevWaterPerStage(state, value) {
      state.form.prevWaterPerStage = value;
    },


    /**
     * 
     * @param {*} state 
     * @param {Array} tanks 
     */
    updateInjectionRatio(state, tanks) {
      state.tanks = state.tanks.map((n, i) => {
        n.injection_ratio = tanks[i].InjectionRatio;
        return n;
      });
    },


    setTanks(state, data) {
      state.tanks = data;
    },
    setTankById(state, params) {
      state.tanks = state.tanks.map(n => {
        // n.Volume = Math.round(0 + n.Volume);
        if(n.id == params.container) {
          n.tank = params.new_tank;
          n.applications = params.new_tank.NumberofApplication;

        }
        return n;
      });
    },

    saveStages (state, data) {
      state.stages = data;
    },

    /**
     * To make object that inside wrapper equals to wrapper (that used for inputs)
     * @param {*} state 
     */
    syncTankObjectsWithInputs(state) {
      state.tanks.forEach(n => {
        n.tank.NumberofApplication = n.applications;
        n.tank.InjectionRatio = n.injection_ratio;
        n.tank.Volume = n.volume;
      });
    }
  },
  actions: {

    async onUpdate({ dispatch, rootGetters }) {

      const prog = rootGetters['program/data'];

      await dispatch('program/steps/setCurrentStep', 'fertigation', { root: true });
      // await dispatch('program/steps/setCurrentStepNextFromSelectedStep', 'fertigation', { root: true });

      dispatch('program/blend/destroyState', '', { root: true });
    },

    async loadStages({ commit, rootGetters }) {
      await ProgramAPI.getFertilizerSchedule(rootGetters['program/data'].id)
        .then(res => {
          commit('saveStages', res.data.data.stages);
        });
    },

    destroyState({ state, commit }) {
      commit('reset');
    },

    getTanks({ state, commit, rootGetters, getters }) {
      return ProgramAPI.getFertigationTanks({
        ...state.form,
        programId: rootGetters['program/data'].id,
      }).then(res => {
        commit('setTanks', getters.processTanks(res.data.data.Tank));
      });
    },


    updateTank({ state, commit, rootGetters, getters }, container) {

      container = state.tanks.find(n => n.id == container);
      const tank = container.tank;

      return ProgramAPI.updateFertigationTank({
        ...state.form,
        programId: rootGetters['program/data'].id,
        tank: tank,
        volume: container.volume,
        injection_ratio: container.injection_ratio,
      }).then(res => {
        console.log(res)
        commit('syncTankObjectsWithInputs');
        commit('setTankById', {
          new_tank: res.data.data,
          container: container.id,
        });
      }).catch(err => {

      });
    },

    updateTanksWithWaterPerStage({ state, commit, rootGetters }) {

      commit('syncTankObjectsWithInputs');

      return ProgramAPI.updateFertigationTanksWithWaterPerStage({
        ...state.form,
        programId: rootGetters['program/data'].id,
        tanks: state.tanks.map(n => n.tank),
      }).then(res => {
        const tanks = res.data.data.Tank;
        commit('updateInjectionRatio', tanks);
      }).catch(err => {

      });
    },

    /**
     * Sorry for duplicate - fuck this algo API
     * 
     * @param {*} param0 
     * @param {*} container 
     */
    updateTankWithApplication({ state, commit, rootGetters }, container) {

      container = state.tanks.find(n => n.id == container);
      const tank = container.tank;

      commit('syncTankObjectsWithInputs');

      return ProgramAPI.updateFertigationTankWithApplication({
        ...state.form,
        programId: rootGetters['program/data'].id,
        tank: tank,
        applications: container.applications,
      }).then(res => {
        commit('setTankById', {
          new_tank: res.data.data,
          container: container.id,
        });
      }).catch(err => {

      });
    },


    async save({ state, commit, rootGetters, dispatch }) {
      await ProgramAPI.saveFertigationStep({
        form: state.form,
        programId: rootGetters['program/data'].id,
        tanks: state.tanks,
      });

      await dispatch('onUpdate');
    },


    get({ state, commit, rootGetters }) {
      return ProgramAPI.getFertigationStep({
        programId: rootGetters['program/data'].id,
      }).then(res => {
        console.log(res.data);
        
        if(res.data.form) {
          commit('setForm', res.data.form);
        }
        if(res.data.tanks) {
          commit('setTanks', res.data.tanks);
        }

      }).catch(err => {

      });
    },
  },
  getters: {
    
    form(state) {
      return state.form
    },

    tanks(state) {
      return state.tanks;
    },

    processTanks: state => tanks => {
      return tanks.map((n, i) => {
        n.Volume = Math.round(parseFloat(n.Volume));
        n.Fertilizers.Fertilizer = n.Fertilizers.Fertilizer.filter(n => parseFloat(n.VolumeMass));
        
        return {
          id: Math.UUID(),
          name: (i + 1).toLetter(),
          applications: n.NumberofApplication,
          injection_ratio: n.InjectionRatio,
          volume: n.Volume,
          start_applications: n.NumberofApplication,
          tank: n,
        };
      })
    },

    stages (state) {
      return state.stages;
    },

    getStage: state => stage_id => {
      return state.stages.find(n => n.id === (stage_id || state.form.stageId))
    },
  }
};
